// Copyright (c) 2005-2019, Coveo Solutions Inc.
"use strict";
var SearchExpressionHelper = (function () {
    function SearchExpressionHelper(expressionHelperUtilities) {
        this.utilities = expressionHelperUtilities;
    }
    SearchExpressionHelper.prototype.getSourcesAndCollectionsExpression = function (collectionsOptions, sourcesOptions, externalContentFromCurrentTab) {
        var newExpression;
        var sourcesExpression = this.getSourcesExpression(sourcesOptions, externalContentFromCurrentTab);
        var externalCollections = this.getAllExternalCollections(collectionsOptions, externalContentFromCurrentTab);
        if (externalCollections.length > 0) {
            var externalCollectionsExpression = this.utilities.getExternalCollectionsExpression(externalCollections);
            newExpression = "(" + sourcesExpression + " OR " + externalCollectionsExpression + ")";
        }
        else {
            newExpression = sourcesExpression;
        }
        return newExpression;
    };
    SearchExpressionHelper.prototype.getSearchFilterExpression = function (options, externalContentFromCurrentTab) {
        var expressions = [options.filterExpression];
        if (externalContentFromCurrentTab.externalSourcesFromCurrentTab.length > 0) {
            expressions.push(this.utilities.getExternalSourcesExpression(externalContentFromCurrentTab.externalSourcesFromCurrentTab));
        }
        if (externalContentFromCurrentTab.externalCollectionsFromCurrentTab.length > 0) {
            expressions.push(this.utilities.getExternalCollectionsExpression(externalContentFromCurrentTab.externalCollectionsFromCurrentTab));
        }
        return expressions.join(" OR ");
    };
    SearchExpressionHelper.prototype.getSearchBoostExpression = function (options) {
        return options.boostExpressions;
    };
    SearchExpressionHelper.prototype.getSourcesExpression = function (sourcesExpressionOptions, externalContentFromCurrentTab) {
        var sources = [];
        if (this.utilities.isDefined(sourcesExpressionOptions.indexSourceName)) {
            sources.push(sourcesExpressionOptions.indexSourceName);
        }
        if (sourcesExpressionOptions.externalSources.length > 0) {
            sources.push.apply(sources, sourcesExpressionOptions.externalSources);
        }
        if (externalContentFromCurrentTab.externalSourcesFromCurrentTab.length > 0) {
            sources.push.apply(sources, externalContentFromCurrentTab.externalSourcesFromCurrentTab);
        }
        return this.utilities.getFilterExpression("@syssource", sources);
    };
    SearchExpressionHelper.prototype.getAllExternalCollections = function (externalCollectionsOptions, externalContentFromCurrentTabOptions) {
        var externalSources = [];
        externalSources.push.apply(externalSources, externalCollectionsOptions.externalCollections);
        externalSources.push.apply(externalSources, externalContentFromCurrentTabOptions.externalCollectionsFromCurrentTab);
        return externalSources;
    };
    return SearchExpressionHelper;
}());
exports.__esModule = true;
exports["default"] = SearchExpressionHelper;



//////////////////
// WEBPACK FOOTER
// ./Base/Rules/SearchExpressionsHelper.ts
// module id = 9
// module chunks = 0